import consts from './consts'
import lang from './lang'

export default {
  methods: {
    liveHelper: function () {
      return {
        currentDateTitle: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return undefined
            if (this.hearingIsActive(hearing) || this.hearingIsNotStarted(hearing) || this.hearingIsCanceled(hearing) || this.hearingIsPostponed(hearing)) {
              return hearing.HearingProgramStartDate
            }
          } else if (this.isMeetingActivePausedVoting(live) || this.shouldShowMeetingStartTime(live)) {
            return live.MeetingActivity.MeetingCurrentDate
          }
          return undefined
        },
        currentMainTitle: function (cms, live) {
          var currentTitle = cms.mainBlock.title
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return currentTitle
            if (this.hearingIsCanceled(hearing)) return `${lang.timeOfHearing[cms.lang]} ${hearing.HearingProgramStartTime} ${lang.canceledHearing[cms.lang]}`
            if (this.hearingIsPostponed(hearing)) return `${lang.timeOfHearing[cms.lang]} ${hearing.HearingProgramStartTime} ${lang.postponedHearing[cms.lang]}`
            if (this.hearingIsActive(hearing)) return lang.liveFromHearing[cms.lang]
            if (this.hearingIsNotStarted(hearing)) return lang.hearingStartsAt[cms.lang] + hearing.HearingProgramStartTime
          } else {
            if (!live.MeetingActivity) return currentTitle
            if (this.isPausedMeeting(live)) return cms.mainBlock.meetingPausedTitle
            if (this.isActiveMeeting(live) || this.isVotingInMeeting(live)) return lang.liveFromMeeting[cms.lang]
            if (this.shouldShowMeetingStartTime(live)) return lang.meetingStartsAt[cms.lang] + live.MeetingActivity.MeetingNextStartTime
          }
          return currentTitle
        },
        mainText: function (cms, live) {
          var text = cms.mainBlock.mainText
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (this.hearingIsCanceled(hearing) || this.hearingIsPostponed(hearing)) return `${hearing.CommitteeName} ${lang.hasHearingInCase[cms.lang]}: <a href=${hearing.ProceedingLinkUrl} title=${hearing.ProceedingTitle}'>${hearing.ProceedingTitle}</a>`
            if (!hearing) return text
          } else {
            if (this.isVotingInMeeting(live)) return cms.mainBlock.votingInMeetingText
            if (this.isPausedMeeting(live)) return cms.mainBlock.meetingPausedText
            if (this.isActiveMeetingWithoutActiveProceeding(live)) return cms.mainBlock.noActiveProceedingsInMeetingText
            if (!this.isActiveMeeting(live) && !this.shouldShowMeetingStartTime(live)) return text
          }
          return undefined
        },
        hearingLingerText: function (cms, live) {
          if (!this.mainBlockIsHearing(cms)) return undefined
          var hearing = this.activeHearing(cms, live)
          if (!hearing) return undefined
          if (this.hearingIsFinished(hearing)) return cms.mainBlock.hearingFinishedText
          return undefined
        },
        shouldShowImageLink: function (cms, live) {
          if (!cms.mainBlock.imageLink) return false
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return false
            return this.hearingIsActive(hearing) || this.hearingIsNotStarted(hearing)
          } else {
            return this.isMeetingActivePausedVoting(live) || this.shouldShowMeetingStartTime(live)
          }
        },
        canceledHearing: function (cms, live) {
          var hearing = this.activeHearing(cms, live)
          if (hearing && hearing.HearingActivityStatus === consts.hearingStatus.canceled) return true
        },
        postponedHearing: function (cms, live) {
          var hearing = this.activeHearing(cms, live)
          if (hearing && hearing.HearingActivityStatus === consts.hearingStatus.postponed) return true
        },
        shouldShowMeetingAttendees: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) return false
          if (!this.isActiveMeeting(live) && !this.shouldShowMeetingStartTime(live)) return false
          return this.hasMeetingAttendees(live)
        },
        shouldShowMainUrl: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return false
            return this.hearingIsActive(hearing) || this.hearingIsNotStarted(hearing)
          } else {
            if (this.isActiveMeetingWithoutActiveProceeding(live)) return false
            return this.isActiveMeeting(live) && this.hasAgendaItem(live)
          }
        },
        shouldShowMeetingButtons: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) return false
          if (this.isMeetingActivePausedVoting(live) || this.shouldShowMeetingStartTime(live)) return true
          return false
        },
        shouldShowHearingButtons: function (cms, live) {
          if (!this.mainBlockIsHearing(cms)) return false
          var hearing = this.activeHearing(cms, live)
          return !!hearing
        },
        shouldShowLinkList: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return true
          } else {
            if (!this.isActiveMeeting(live) &&
            !this.shouldShowMeetingStartTime(live)) return true
          }
          return false
        },
        shouldShowSlider: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            if (this.isActiveMeeting(live) || this.shouldShowMeetingStartTime(live)) return true
            if (!live.HearingActivityList) return false
            var hearing = this.activeHearing(cms, live)
            if (!hearing && live.HearingActivityList.length > 0) return true
            if (this.hearingIsFinished(hearing)) return true
            var hearings = live.HearingActivityList.filter(h => h.HearingId !== hearing.HearingId)
            if (hearings.length > 0) return true
            return false
          } else {
            return (live.HearingActivityList && live.HearingActivityList.length > 0) || live.FinishedMeeting
          }
        },
        isVotingOrActiveWithActiveProceedingOrActiveHearing: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return false
            return this.hearingIsActive(hearing)
          } else {
            return (this.isActiveMeeting(live) && this.meetingHasActiveProceeding(live)) || this.isVotingInMeeting(live)
          }
        },
        isPreLive: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return false
            return this.hearingIsNotStarted(hearing)
          } else {
            return this.shouldShowMeetingStartTime(live)
          }
        },
        isActiveMeetingWithoutActiveProceeding: function (live) {
          // An order number of 0 means that there are no active
          // proceedings in the meeting.
          return this.isMeetingActivePausedVoting(live) && !this.meetingHasActiveProceeding(live)
        },
        meetingHasActiveProceeding: function (live) {
          return this.agendaItem(live).OrderNumber > 0
        },
        isActiveMeeting: function (live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingActivityStatus === consts.meetingStatus.active
        },
        isMeetingActivePausedVoting: function (live) {
          return this.isActiveMeeting(live) || this.isPausedMeeting(live) || this.isVotingInMeeting(live)
        },
        isVotingInMeeting: function (live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingActivityStatus === consts.meetingStatus.voting
        },
        isPausedMeeting: function (live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingActivityStatus === consts.meetingStatus.pause
        },
        shouldShowMeetingStartTime: function (live) {
          return live.MeetingActivity && live.MeetingActivity.MeetingShouldShowMeetingStartTime
        },
        mainBlockIsHearing: function (cms) {
          return cms.mainBlock.type !== consts.meetingRoom.s.enumId
        },
        hearingIsActive: function (hearing) {
          return hearing.HearingActivityStatus === consts.hearingStatus.active
        },
        hearingIsCanceled: function (hearing) {
          return hearing.HearingActivityStatus === consts.hearingStatus.canceled
        },
        hearingIsPostponed: function (hearing) {
          return hearing.HearingActivityStatus === consts.hearingStatus.postponed
        },
        hearingIsNotStarted: function (hearing) {
          return hearing.HearingActivityStatus === consts.hearingStatus.notStarted
        },
        hearingIsFinished: function (hearing) {
          return hearing.HearingActivityStatus === consts.hearingStatus.finished
        },
        activeHearing: function (cms, live) {
          if (!live.HearingActivityList) return undefined
          var hearings = live.HearingActivityList.filter(hearing => hearing.HearingId === cms.mainBlock.activeHearingId)
          if (hearings.length > 0) return hearings[0]
          return undefined
        },
        meetingRoomIdFromEnumId: function (enumId) {
          var room = consts.meetingRoom.filter(room => room.enumId === enumId)
          return room ? room.nameId : undefined
        },
        hasMeetingAttendees: function (live) {
          return live.MeetingActivity.ParticipatingGovernmentMemberList &&
            live.MeetingActivity.ParticipatingGovernmentMemberList.length > 0
        },
        hasAgendaItem: function (live) {
          return live.MeetingActivity.CurrentHandlingAgendaItemList &&
            live.MeetingActivity.CurrentHandlingAgendaItemList.length > 0
        },
        hasLinkList: function (cms) {
          return cms.mainBlock.linkList && cms.mainBlock.linkList.length > 0
        },
        agendaItem: function (live) {
          return live.MeetingActivity.CurrentHandlingAgendaItemList[0]
        },
        agendaUrl: function (live) {
          return live.MeetingActivity.MeetingAgendaLinkUrl
        },
        hearingProgramUrl: function (cms, live) {
          var hearing = this.activeHearing(cms, live)
          return hearing.HearingProgramLinkUrl
        },
        meetingTime: function (cms, live) {
          if (this.mainBlockIsHearing(cms)) {
            var hearing = this.activeHearing(cms, live)
            if (!hearing) return undefined
            return hearing.HearingProgramStartTime
          } else {
            if (!live.MeetingActivity) return undefined
            return live.MeetingActivity.MeetingNextStartTime
          }
        },
        statusFromMeetingStatus: function (status) {
          switch (status) {
            case consts.meetingStatus.active:
              return consts.status.active
            case consts.meetingStatus.notStarted:
              return consts.status.before
            case consts.meetingStatus.pause:
              return consts.status.paused
            default:
              return consts.status.notDetermined
          }
        },
        statusFromHearingStatus: function (status) {
          switch (status) {
            case consts.hearingStatus.active:
              return consts.status.active
            case consts.hearingStatus.notStarted:
              return consts.status.before
            case consts.hearingStatus.finished:
              return consts.status.finished
            case consts.hearingStatus.canceled:
              return consts.status.canceled
            case consts.hearingStatus.postponed:
              return consts.status.postponed
            default:
              return consts.status.notDetermined
          }
        },
        sliderItems: function (cms, live) {
          var list = []
          if (this.mainBlockIsHearing(cms) && live.MeetingActivity &&
            (cms.simulateSameDay || this.isSameDay(live.MeetingActivity.MeetingStartDateAndTimeIsoFormat))) {
            let stortingMeeting = {
              startTime: live.MeetingActivity.MeetingStartTime,
              status: this.statusFromMeetingStatus(live.MeetingActivity.MeetingActivityStatus),
              id: lang.stortinget[cms.lang],
              textLink: live.MeetingActivity.MeetingAgendaLinkUrl,
              title: live.MeetingActivity.MeetingAgendaLinkText,
              videoLink: cms.main.link,
              image: cms.main.image,
              snapshot: cms.main.snapshot,
              fallback: cms.main.fallback,
              altText: cms.main.altText,
              isHearing: false
            }
            list.push(stortingMeeting)
          }
          if (live.FinishedMeeting) {
            let stortingMeeting = {
              startTime: live.FinishedMeeting.MeetingStartTime,
              videoLink: live.FinishedMeeting.MeetingVideoUrl,
              status: consts.status.finished,
              id: lang.stortinget[cms.lang],
              textLink: live.FinishedMeeting.AgendaLink,
              title: live.FinishedMeeting.AgendaText,
              image: cms.main.image,
              fallback: cms.main.fallback,
              altText: cms.main.altText,
              isHearing: false
            }
            list.push(stortingMeeting)
          }

          var hearings = live.HearingActivityList
          if (hearings && hearings.length > 0) {
            for (let hearing of hearings) {
              if (hearing.HearingId === cms.mainBlock.activeHearingId && !this.hearingIsFinished(hearing)) continue
              var hearingCmsData
              switch (hearing.HearingRoomId) {
                case consts.meetingRoom.h1.nameId:
                  hearingCmsData = cms.h1
                  break
                case consts.meetingRoom.h2.nameId:
                  hearingCmsData = cms.h2
                  break
                case consts.meetingRoom.n202.nameId:
                  hearingCmsData = cms.h3
                  break
                default:
                  continue
              }
              let sliderItem = this.createHearingSliderItem(hearing, hearingCmsData)
              list.push(sliderItem)
            }
          }
          if (list.length > 0) list.sort((a, b) => this.compare(b.status, a.status) || this.compare(a.startTime, b.startTime))
          return list
        },
        createHearingSliderItem: function (hearing, hearingCmsData) {
          let status = this.statusFromHearingStatus(hearing.HearingActivityStatus)
          return {
            startTime: hearing.HearingProgramStartTime,
            status: status,
            id: hearing.HearingId,
            textLink: hearing.ProceedingLinkUrl,
            title: hearing.ProceedingTitle,
            videoLink: status === consts.status.finished ? hearing.HearingVideoUrl : hearingCmsData.link,
            image: hearingCmsData.image,
            snapshot: hearingCmsData.snapshot,
            fallback: hearingCmsData.fallback,
            altText: hearingCmsData.altText,
            isHearing: true
          }
        },
        isSameDay: function (meetingDateString) {
          var meetingDate = new Date(meetingDateString.substr(0, meetingDateString.indexOf(' ')))
          var now = new Date()
          return now.toDateString() === meetingDate.toDateString()
        },
        numberOfFinished: function (cms, live) {
          var counter = 0
          if (live.HearingActivityList) {
            var hearings = live.HearingActivityList.filter(hearing => hearing.HearingActivityStatus === consts.hearingStatus.finished)
            counter = hearings.length
          }
          if (live.FinishedMeeting) counter++
          return counter
        },
        compare: function (a, b) {
          if (a > b) return +1
          if (a < b) return -1
          return 0
        },
        blobToImageSrc: function (blob) {
          var urlCreator = window.URL || window.webkitURL
          var binaryData = []
          binaryData.push(blob)
          return urlCreator.createObjectURL(new Blob(binaryData, {type: 'application/zip'}))
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js